// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3bRrh","list":"BalanceDue_list__15l1b","listRow":"BalanceDue_listRow__1ZRXB","total":"BalanceDue_total__3BVUU"};